import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

import conference from './store/conference';
import language from './store/language';
import user from './store/user';
import hub from './store/hub';
import notifications from './store/notifications';

const debug = process.env.NODE_ENV !== 'production'

const vuexPersist = new VuexPersist({
    key: 'profile',
    storage: window.localStorage,
    reducer: state => ({
        conference: { current: state.conference.current },
        language: state.language,
        user: state.user
    })
})

export default new Vuex.Store({
    modules: {
        conference,
        language,
        user,
        hub,
        notifications
    },
    plugins: [vuexPersist.plugin],
    strict: debug,
});